import { useTranslation } from "react-i18next";
import useScrollOnMount from "src/hooks/App/useScrollOnMount";
import PagesHistory from "../shared/minicomponents/pagehistory/PagesHistory";
import ForYouSection from "../shared/section/ForYouSection/ForYouSection";
import OrderProducts from "./cartproduct/OrderProducts";
import s from "./OrderPage.module.scss";
import OrderPageButtons from "./orderpagebutton/OrderPageButtons";

const OrderPage = () => {
  const { t } = useTranslation();

  useScrollOnMount(200);

  return (
    <div className="container">
      <main className={s.orderPage}>
        <PagesHistory history={["/", t("history.orders")]} />

        <div className={s.pageComponents} id="order-page">
          <OrderProducts />
          <OrderPageButtons />
          <ForYouSection />
        </div>
      </main>
    </div>
  );
};
export default OrderPage;
